import
React, {
  useState,
  useContext,
  useEffect
} from 'react';

import {
  Colors
} from 'src/Common/Colors';

import Input from 'src/Common/Components/Input/Input';

import PrimaryButton from 'src/Common/Components/PrimaryButton/PrimaryButton';

import PartnerPortalLogo from 'src/Common/Images/partner-portal-logo.png';

import PartnerText from 'src/Common/Images/partnew-text.png';

import {
  isValidSAMsisdn
} from 'src/Common/constants';

import {
  OTP
} from 'src/Components/Common';

import {
  SalesContext
} from 'src/Context/SalesContext';

import {
  getPortalOTP,
  validatePortalOTP
} from 'src/Services/Services';

import {
  tagOnPortalLoginButtonClick,
  tagOnPortalLoginDismissButtonClick,
  tagOnPortalLoginLoad,
  tagOnPortalLoginOtpBlockedLoad,
  tagOnPortalLoginOtpFail,
  tagOnPortalLoginOtpLoad,
  tagOnPortalLoginResendOtpButtonClick,
  tagOnPortalLoginSubmitOtpButtonClick
} from 'src/Tagging/SalesTagging';

import 'src/UI/PortalLogIn/PortalLogIn.css';

const PortalLogIn = () => {

  const context = useContext(SalesContext);

  const [ showOTP, setShowOTP ] = useState(false);
  const [ message, setMessage ] = useState('');
  const [ errorMessage, setErrorMessage ] = useState(null);
  const [ responseError, setResponseError ] = useState(null);
  const [ isOtpAttemptFail, setIsOtpAttemptFail ] = useState(false);
  const [ isOtpBlocked, setIsOtpBlocked ] = useState(false);

  const [ form, setForm ] = useState({
    formComponents: [
      {
        'key': 'username',
        'label': 'Username',
        'type': 'input',
        'value': '',
        'validations': {
          'invalidMessage': 'Please enter your username'
        },
        'config': {
          'type': 'text',
          'required': true,
          'placeholder': 'Enter your username',
          'tabIndex': '1'
        },
        'isValid': false,
        'isTouched': false
      },
      {
        'key': 'number',
        'label': 'Cell phone number',
        'type': 'input',
        'value': '',
        'validations': {
          'invalidMessage': 'Please enter your cell phone number'
        },
        'config': {
          'type': 'text',
          'required': true,
          'placeholder': 'Enter your cell phone number',
          'tabIndex': '2'
        },
        'isValid': false,
        'isTouched': false
      }
    ],
    isFormValid: false
  });

  const formComponentChangeHandler = (value, inputIdentifier) => {

    setResponseError(null);
    setErrorMessage(null);

    const formCompsCopy = [ ...form.formComponents ];

    const changedComponentIndex = formCompsCopy.findIndex(comp => comp.key === inputIdentifier);

    formCompsCopy[changedComponentIndex].value = value;
    formCompsCopy[changedComponentIndex].isTouched = true;

    switch (inputIdentifier) {

    case 'username':

      formCompsCopy[changedComponentIndex].isValid = value.length > 2;
      break;

    case 'number':

      formCompsCopy[changedComponentIndex].isValid = isValidSAMsisdn(value);
      break;

    default:

      formCompsCopy[changedComponentIndex].isValid = false;
      break;
    }

    const isFormValid = formCompsCopy.find(e => e.isValid === false) ? false : true;

    setForm({
      formComponents: formCompsCopy,
      isFormValid: isFormValid
    });
  };

  const onSubmitForm = (isResend) => {

    isResend ? tagOnPortalLoginResendOtpButtonClick() : tagOnPortalLoginButtonClick();

    context.setShowSpinner(true);

    getPortalOTP(form.formComponents[0].value, form.formComponents[1].value)
      .then(res => {

        context.setShowSpinner(false);

        if (res.ok && res.result?.message) {

          const retailUserDetails = {
            username: form.formComponents[0].value,
            msisdn: form.formComponents[1].value
          };

          sessionStorage.setItem('retailUserDetails', JSON.stringify(retailUserDetails));

          setMessage(res.result?.message);
          setShowOTP(true);

          tagOnPortalLoginOtpLoad();
        }
      })
      .catch(error => {

        context.setShowSpinner(false);

        if (error?.response?.status === 404) {

          if (error?.response?.data?.result?.code) {

            setErrorMessage('We can\'t find an account matching that username.');
            setResponseError('username');
          } else {

            setErrorMessage('We can\'t find an account matching that cell phone number.');
            setResponseError('number');
          }

          return;
        }

        if (error?.response?.status === 400) {

          setErrorMessage(error?.response?.data?.result?.message);
          setResponseError('username');

          return;
        }

        if (error?.response?.status === 423) {

          setIsOtpBlocked(true);
          setShowOTP(true);
        }

      });
  };

  const onOtpSubmit = (otpValue) => {

    tagOnPortalLoginSubmitOtpButtonClick();

    context.setShowSpinner(true);

    const username = form.formComponents[0].value || JSON.parse(sessionStorage.getItem('retailUserDetails')).username;

    validatePortalOTP(username, otpValue)
      .then(res => {

        context.setShowSpinner(false);

        if (res.ok && res.result?.message) {

          window.location.href = '/vodacom/fibre/sales/leads';
        }
      })
      .catch(error => {

        context.setShowSpinner(false);

        if (error?.response?.status === 422) {

          setIsOtpAttemptFail(true);

          tagOnPortalLoginOtpFail('Looks like you entered an invalid OTP. Please try again.');

          return;
        }

        if (error?.response?.status === 423) {

          tagOnPortalLoginOtpBlockedLoad();

          setIsOtpBlocked(true);
        }
      });
  };

  const warningMsgOnclick = () => {

    tagOnPortalLoginDismissButtonClick();

    setIsOtpAttemptFail(false);
  };

  const onCloseOTP = () => {

    setShowOTP(false);
  };

  useEffect(() => {

    tagOnPortalLoginLoad();
  }, []);

  return (
    <div className={'login-portal-container'}>

      <div className={'login-logo-container'}>

        <img
          src={ PartnerPortalLogo }
          className={'login-logo'} />

      </div>

      <div className={'login-container'}>

        <div className={'login-wrapper'}>

          <div className={'login-heading-section'}>

            <div className={'login-heading-text'}>

              Log in to your
            </div>

            <img
              src={PartnerText}
              className={'login-heading-logo'} />

            <div className={'login-heading-text'}>

              Portal
            </div>

          </div>

          <div className={'login-details-section'}>

            { form.formComponents.map((item, index) => {

              return (

                <Input
                  key={index}
                  {...item}
                  validations={
                    { invalidMessage: responseError && responseError === item.key ? errorMessage : item.validations.invalidMessage }
                  }
                  isValid={responseError && responseError === item.key ? false : item.isValid}
                  updateValue={formComponentChangeHandler}
                  inputIdentifier={item.key} />
              );
            })}

            <div className={'login-button-wrapper'}>

              <PrimaryButton
                className={'login-button'}
                buttonText={'Log in'}
                onClick={() => onSubmitForm(false)}
                isEnabled={form.isFormValid}
                activeBackgroundColor={Colors.ElectricRed}
                inActiveBackgroundColor={Colors.GrainOfSalt}
                display={'inline-block'}
                width={'100%'}
                padding={'1em'}
                margin={'0'}
                color={form.isFormValid ? Colors.White : Colors.GrainOfSalt}
                borderRadius={'25px'}
                fontWeight={'700'}
                showIcon={false} />

            </div>

          </div>

        </div>

      </div>

      { showOTP &&

        <OTP
          close={onCloseOTP}
          onResendOtp={onSubmitForm}
          onSubmit={onOtpSubmit}
          showError={isOtpAttemptFail}
          isAccountBlocked={isOtpBlocked}
          warningMsgOnclick={warningMsgOnclick}
          message={message}
          otpLength={6}/>
      }
    </div>
  );
};

export default PortalLogIn;